import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=2593e171&"
import script from "./BackButton.vue?vue&type=script&lang=js&"
export * from "./BackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2593e171')) {
      api.createRecord('2593e171', component.options)
    } else {
      api.reload('2593e171', component.options)
    }
    module.hot.accept("./BackButton.vue?vue&type=template&id=2593e171&", function () {
      api.rerender('2593e171', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/BackButton.vue"
export default component.exports